export const DOMAIN_REGEX = /(.+)\.pkuschool\.edu\.cn/
export const HOSTNAME = 'pkuschool.edu.cn'

// 可信任的域名
export const TRUSTED_DOMAINS = ['user', 'activity', 'portal']

export const USER_SUBDOMAIN = 'portal' as const
export const ACTIVITY_SUBDOMAIN = 'activity' as const
export const MOBILE_SUBDOMAIN = 'mobile' as const

export const ACTIVITY_DOMAIN_REGEX = /^activity\.pkuschool\.edu\.cn$/
export const ACTIVITY_DOMAIN = 'activity.pkuschool.edu.cn' as const
export const USER_DOMAIN = `${USER_SUBDOMAIN}.${HOSTNAME}` as const
export const MOBILE_DOMAIN = `${MOBILE_SUBDOMAIN}.${HOSTNAME}` as const

export const LOCAL_HOST_FRAGMENT = 'local.growp.com' as const
export const STAGING_USER_HOST = 'user.growp.staging.seiue.com' as const

export const buildGrowpDomain = (subdomain: string) =>
  `${subdomain}.${HOSTNAME}` as const
